import gql from "graphql-tag";

// noinspection GraphQLUnresolvedReference
export const currentPeriodQuery = gql`
            query {
                records:periods(isCurrentPeriod:true){
                    weekId
                    endDate
                    quadId
                    periodAbbreviation
                    legacyPeriod
                }
            }`;